import React from 'react'
import { FadingBalls } from 'react-cssfx-loading/lib'

function MapLoading() {
  return (
      <div  className='map bg-ark map-load' >
      </div>
  )
}

export default MapLoading